// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 19-design-system.md
// About card: prose summary of an app derived from its doc fields. Shown in the
// Overview tab hero row alongside the screenshot gallery.
import * as React from 'react';

import { AD_CARD, AD_CARD_HD } from '@/components/greenlight/surfaces';

interface AboutCardProps {
  summary: string | null;
  purpose: string | null;
  architecture: string | null;
  description?: string | null;
}

export function AboutCard({
  summary,
  purpose,
  architecture,
  description,
}: AboutCardProps): React.JSX.Element {
  const lead = summary?.trim() || description?.trim() || null;
  const hasDocs = Boolean(lead || purpose?.trim() || architecture?.trim());

  if (!hasDocs) {
    return (
      <div data-testid="about-card" className={AD_CARD}>
        <div className={AD_CARD_HD}>
          <span className="text-sm font-semibold tracking-[-0.01em]">About this app</span>
        </div>
        <div className="p-5 text-sm text-muted-foreground">
          Architecture docs appear after the first successful deployment.
        </div>
      </div>
    );
  }
  return (
    <div data-testid="about-card" className={AD_CARD}>
      <div className={AD_CARD_HD}>
        <span className="text-sm font-semibold tracking-[-0.01em]">About this app</span>
      </div>
      <div className="p-5 space-y-3 text-sm">
        {/* All prose renders expanded inside one bounded scroll region, so the
            hero zone keeps a fixed height while long architecture docs stay
            fully reachable in place. */}
        <div className="max-h-56 space-y-3 overflow-y-auto pr-1" data-testid="about-docs">
          {lead && <p>{lead}</p>}
          {purpose && (
            <div>
              <div className="text-xs uppercase tracking-wide text-muted-foreground">Purpose</div>
              <p>{purpose}</p>
            </div>
          )}
          {architecture && (
            <div>
              <div className="text-xs uppercase tracking-wide text-muted-foreground">
                Architecture
              </div>
              <p>{architecture}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
